import { Stack, Pagination, Select, MenuItem } from "@mui/material";
import React from "react";

import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

export default function FooterPagination({
  totalPages,
  totalDocs,
  limit,
  page,
  setPage,
  handleLimit,
  Type,
  setLoading,
}) {
  // Change Language
  const { language } = React.useContext(AuthContext);
  const { t } = translateLauguage(language);

  const handlePageNum = (event, pageNum) => {
    setPage(parseInt(pageNum));
    if (Type === "student") {
      window.localStorage.setItem("pageStudent", parseInt(pageNum));
    } else if (Type === "parent") {
      window.localStorage.setItem("pageParent", parseInt(pageNum));
    }
  };
  return (
    <Stack
      direction="row"
      justifyContent="right"
      spacing={2}
      sx={{ marginTop: "20px" }}
    >
      <Stack direction="column" justifyContent="center">
        <Pagination
          hideNextButton={false}
          hidePrevButton={false}
          page={page}
          count={totalPages}
          color="primary"
          variant="outlined"
          onChange={
            (event, pageNum) => {
              handlePageNum(event, pageNum);
              setLoading(true);
            }
            // {
            // setPage(parseInt(pageNum));

            // window.localStorage.setItem(
            //   "pageClickStudentId",
            //   parseInt(pageNum)
            // );
            // }
          }
        />
      </Stack>
      <Select size="small" value={limit} onChange={handleLimit}>
        <MenuItem value={6}>6/{t("page")}</MenuItem>
        <MenuItem value={8}>8/{t("page")}</MenuItem>
        <MenuItem value={10}>10/{t("page")}</MenuItem>
        <MenuItem value={12}>12/{t("page")}</MenuItem>
        <MenuItem value={totalDocs}>{t("all")}/{t("page")}</MenuItem>
      </Select>
    </Stack>
  );
}
